module.exports = __webpack_public_path__ + "img/edifier-logo-color.323c320d.svg";